import React, { useEffect, useState } from 'react'
import PageMainBanner from '../../comps/PageMainBanner'
import DomainAmt from './DomainAmt'
import DomainPricing from './DomainPricing'
import Footer from '../../comps/Footer'
import Header from '../../comps/Header'
import Faqs from '../faqs/Faqs'
import DomainFeatures from './DomainFeatures'
import { get_main_banner_section } from '../../api/Global'
import { IMG_BASE_URL } from '../../config/Base_Url_Config'
import More_Hosting from '../more_hosting/More_Hosting'

const Domain = () => {
      const [get_banner_list, set_Banner_List] = useState([]);

      // <----------- render the main banner section ---------->
      useEffect(() => {
            const handle_get_main_banner_section = async () => {
                  try {
                        const response = await get_main_banner_section();
                        set_Banner_List(response?.data?.data?.banners)
                  } catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_main_banner_section();
      }, [])
      return (
            <div>
                  <Header />
                  <PageMainBanner heading="Domain" title={get_banner_list?.domain_title} 
                  para={get_banner_list?.domain_description} image={get_banner_list?.web_hosting_image ? 
                  `${IMG_BASE_URL}/${get_banner_list?.domain_image}` : "assets/images/server-img.png"} />
                  <DomainAmt />
                  {/* <DomainPricing /> */}
                  <DomainFeatures />
                  <section className="relative">
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-light/30" />
                        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-blue-500/5 via-transparent to-transparent blur-2xl">
                        </div>
                        <div className="relative py-10 md:py-24 sm:py-32 overflow-hidden">
                              <div className="absolute inset-0 -z-10">
                                    <div className="absolute inset-0 bg-gradient-to-b from-[#fafafa] via-[#fafafa] to-[#fafafa]">
                                    </div>
                                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px]">
                                          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-blue-600/10 blur-[120px] animate-slow-pulse">
                                          </div>
                                    </div>
                              </div>
                              {/* <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                    <div className="mx-auto max-w-2xl text-center mb-16">
                                          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl"><span className="sm:inline md:inline">FAQ's</span></h2>
                                          <p className="text-gray-400 pt-3">FAQs About Locknpay's Domain</p>
                                    </div>
                                    <div className="transition-transform duration-500 ease-out">
                                          <div className="w-full mx-auto sm:w-10/12 md:w-2/1">
                                                <div className="mt-2 divide-y divide-slate-100">
                                                      {
                                                            get_faqs?.map((get_faqs_result) => {
                                                                  return (
                                                                        <>
                                                                              <details className="group rounded-2xl bg-white border-1 border-blue-400/30 p-3 mt-3">
                                                                                    <summary className="flex w-full cursor-pointer justify-between text-left text-base/7 font-semibold text-slate-900 select-none group-open:text-indigo-600">
                                                                                          {get_faqs_result?.question}
                                                                                          <svg className="mt-0.5 ml-4 size-6 flex-none stroke-slate-700 group-open:stroke-indigo-500" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                                                                                <path d="M18 12H6" />
                                                                                                <path className="group-open:hidden" d="M12 6v12" />
                                                                                          </svg></summary>
                                                                                    <div className="prose prose-slate prose-a:font-semibold prose-a:text-indigo-600 prose-a:hover:text-indigo-500 max-w-none bg-white p-3 text-gray-500">
                                                                                          <p>{get_faqs_result?.answer}</p>
                                                                                    </div>
                                                                              </details>
                                                                        </>
                                                                  )
                                                            })
                                                      }
                                                </div>
                                          </div>
                                    </div>
                              </div> */}
                              <Faqs />
                        </div>
                  </section>
                  {/*  */}
                  <More_Hosting />
                  {/*  */}
                  <Footer />

            </div>
      )
}

export default Domain